export const supportedOcrLanguages = [
  { code: "afr", name: "Afrikaans" },
  { code: "amh", name: "Amharic" },
  { code: "ara", name: "Arabic" },
  { code: "asm", name: "Assamese" },
  { code: "aze", name: "Azerbaijani" },
  { code: "aze_cyrl", name: "Azerbaijani - Cyrilic" },
  { code: "bel", name: "Belarusian" },
  { code: "ben", name: "Bengali" },
  { code: "bod", name: "Tibetan" },
  { code: "bos", name: "Bosnian" },
  { code: "bre", name: "Breton" },
  { code: "bul", name: "Bulgarian" },
  { code: "cat", name: "Catalan; Valencian" },
  { code: "ceb", name: "Cebuano" },
  { code: "ces", name: "Czech" },
  { code: "chi_sim", name: "Chinese - Simplified" },
  { code: "chi_tra", name: "Chinese - Traditional" },
  { code: "chr", name: "Cherokee" },
  { code: "cos", name: "Corsican" },
  { code: "cym", name: "Welsh" },
  { code: "dan", name: "Danish" },
  { code: "dan_frak", name: "Danish - Fraktur (contrib)" },
  { code: "deu", name: "German" },
  { code: "deu_frak", name: "German - Fraktur (contrib)" },
  { code: "deu_latf", name: "German (Fraktur Latin)" },
  { code: "dzo", name: "Dzongkha" },
  { code: "ell", name: "Greek, Modern (1453-)" },
  { code: "eng", name: "English" },
  { code: "enm", name: "English, Middle (1100-1500)" },
  { code: "epo", name: "Esperanto" },
  { code: "equ", name: "Math / equation detection module" },
  { code: "est", name: "Estonian" },
  { code: "eus", name: "Basque" },
  { code: "fao", name: "Faroese" },
  { code: "fas", name: "Persian" },
  { code: "fil", name: "Filipino (old - Tagalog)" },
  { code: "fin", name: "Finnish" },
  { code: "fra", name: "French" },
  { code: "frk", name: "German - Fraktur (now deu_latf)" },
  { code: "frm", name: "French, Middle (ca.1400-1600)" },
  { code: "fry", name: "Western Frisian" },
  { code: "gla", name: "Scottish Gaelic" },
  { code: "gle", name: "Irish" },
  { code: "glg", name: "Galician" },
  { code: "grc", name: "Greek, Ancient (to 1453) (contrib)" },
  { code: "guj", name: "Gujarati" },
  { code: "hat", name: "Haitian; Haitian Creole" },
  { code: "heb", name: "Hebrew" },
  { code: "hin", name: "Hindi" },
  { code: "hrv", name: "Croatian" },
  { code: "hun", name: "Hungarian" },
  { code: "hye", name: "Armenian" },
  { code: "iku", name: "Inuktitut" },
  { code: "ind", name: "Indonesian" },
  { code: "isl", name: "Icelandic" },
  { code: "ita", name: "Italian" },
  { code: "ita_old", name: "Italian - Old" },
  { code: "jav", name: "Javanese" },
  { code: "jpn", name: "Japanese" },
  { code: "kan", name: "Kannada" },
  { code: "kat", name: "Georgian" },
  { code: "kat_old", name: "Georgian - Old" },
  { code: "kaz", name: "Kazakh" },
  { code: "khm", name: "Central Khmer" },
  { code: "kir", name: "Kirghiz; Kyrgyz" },
  { code: "kmr", name: "Kurmanji (Kurdish - Latin Script)" },
  { code: "kor", name: "Korean" },
  { code: "kor_vert", name: "Korean (vertical)" },
  { code: "kur", name: "Kurdish (Arabic Script)" },
  { code: "lao", name: "Lao" },
  { code: "lat", name: "Latin" },
  { code: "lav", name: "Latvian" },
  { code: "lit", name: "Lithuanian" },
  { code: "ltz", name: "Luxembourgish" },
  { code: "mal", name: "Malayalam" },
  { code: "mar", name: "Marathi" },
  { code: "mkd", name: "Macedonian" },
  { code: "mlt", name: "Maltese" },
  { code: "mon", name: "Mongolian" },
  { code: "mri", name: "Maori" },
  { code: "msa", name: "Malay" },
  { code: "mya", name: "Burmese" },
  { code: "nep", name: "Nepali" },
  { code: "nld", name: "Dutch; Flemish" },
  { code: "nor", name: "Norwegian" },
  { code: "oci", name: "Occitan (post 1500)" },
  { code: "ori", name: "Oriya" },
  { code: "osd", name: "Orientation and script detection module" },
  { code: "pan", name: "Panjabi; Punjabi" },
  { code: "pol", name: "Polish" },
  { code: "por", name: "Portuguese" },
  { code: "pus", name: "Pushto; Pashto" },
  { code: "que", name: "Quechua" },
  { code: "ron", name: "Romanian; Moldavian; Moldovan" },
  { code: "rus", name: "Russian" },
  { code: "san", name: "Sanskrit" },
  { code: "sin", name: "Sinhala; Sinhalese" },
  { code: "slk", name: "Slovak" },
  { code: "slk_frak", name: "Slovak - Fraktur (contrib)" },
  { code: "slv", name: "Slovenian" },
  { code: "snd", name: "Sindhi" },
  { code: "spa", name: "Spanish; Castilian" },
  { code: "spa_old", name: "Spanish; Castilian - Old" },
  { code: "sqi", name: "Albanian" },
  { code: "srp", name: "Serbian" },
  { code: "srp_latn", name: "Serbian - Latin" },
  { code: "sun", name: "Sundanese" },
  { code: "swa", name: "Swahili" },
  { code: "swe", name: "Swedish" },
  { code: "syr", name: "Syriac" },
  { code: "tam", name: "Tamil" },
  { code: "tat", name: "Tatar" },
  { code: "tel", name: "Telugu" },
  { code: "tgk", name: "Tajik" },
  { code: "tgl", name: "Tagalog (new - Filipino)" },
  { code: "tha", name: "Thai" },
  { code: "tir", name: "Tigrinya" },
  { code: "ton", name: "Tonga" },
  { code: "tur", name: "Turkish" },
  { code: "uig", name: "Uighur; Uyghur" },
  { code: "ukr", name: "Ukrainian" },
  { code: "urd", name: "Urdu" },
  { code: "uzb", name: "Uzbek" },
  { code: "uzb_cyrl", name: "Uzbek - Cyrilic" },
  { code: "vie", name: "Vietnamese" },
  { code: "yid", name: "Yiddish" },
  { code: "yor", name: "Yoruba" },
] as const;

export type OcrLanguageCode = (typeof supportedOcrLanguages)[number]["code"];
